import * as React from 'react'

const SvgChevronSortIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 17.5l-4.375-4.375.881-.881L10 15.73l3.494-3.487.881.881L10 17.5zm0-15l4.375 4.375-.881.881L10 4.27 6.506 7.756l-.881-.881L10 2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgChevronSortIcon
